import Vue from 'vue'
import axios from 'axios';
import router from '../router/index.js'
import api from '../api/index'

Vue.use(router);
import ElementUI from 'element-ui';

const service = axios.create({
    //使用Nginx代理
    baseURL: '/api',//设置后台连接地址，通过Nginx代理到后端服务
    // 原始地址（备用）:
    // baseURL: 'http://39.107.231.57:8091/api',
    // baseURL: 'http://192.168.1.9:8091/api',
    withCredentials: true
});

service.interceptors.request.use(
    config => {
        config.headers.token = window.sessionStorage.getItem('token');
        return config;
    },
    error => {
        return Promise.reject();
    }
);
// http response 响应拦截器
service.interceptors.response.use(
    response => {
        if (response.data.code == 500) {
            ElementUI.Message({
                message: response.data.message,
                type: "error"
            })
        }
        // if (response.data.code === 401) {
        //     sessionStorage.clear(); //清除浏览器中存储的用户信息
        //     // 检查当前路由是否和目标路由相同
        //     if (router.currentRoute.path !== '/WesteSound-login') {
        //         router.replace("/WesteSound-login");
        //         ElementUI.Message({
        //             message: '登录已过期，请重新登录!',
        //             type: 'warning'
        //         });
        //     }
        // }
        if (response.data.code === 401) {
            // 说明token过期了,刷新token
            const refreshId = window.sessionStorage.getItem('id');
            return api.refreshToken({
                id: refreshId
            }).then(res => {
                if (res.code === 200) {
                    // 刷新token成功，将最新的token更新到header中，同时保存在localStorage中
                    const token = res.data;
                    window.sessionStorage.setItem('token', token)
                    const config = response.config
                    config.headers.token = token;
                    return axios(config).then(newResponse => {
                        return newResponse.data; // 返回重新请求的响应数据
                    });
                }
            }).catch(res => {
                sessionStorage.clear(); //清除浏览器中存储的用户信息
                // 检查当前路由是否和目标路由相同
                if (router.currentRoute.path !== '/WesteSound-login') {
                    router.replace("/WesteSound-login");
                    ElementUI.Message({
                        message: '登录已过期，请重新登录!',
                        type: 'warning'
                    });
                }
            })
        }
        return response.data;
    }, e => {
        return Promise.reject(e);
    }
);


import '../../initialize.js'

export default service;